const FilterIcon = ({ size = 16, stroke = "currentColor", strokeWidth = 1 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Top slider */}
      <line x1="3" y1="5" x2="17" y2="5" />
      <circle cx="6" cy="5" r="2" fill="none" />

      {/* Middle slider */}
      <line x1="3" y1="11" x2="17" y2="11" />
      <circle cx="12" cy="11" r="2" fill="none" />

      {/* Bottom slider */}
      <line x1="3" y1="17" x2="17" y2="17" />
      <circle cx="8" cy="17" r="2" fill="none" />
    </svg>
  )
}

export default FilterIcon
  